import script from "./MallLoginModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallLoginModal.vue?vue&type=script&setup=true&lang=ts"

import "./MallLoginModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__